export interface Media {
  location: MediaLocation; /* Localización de un media (tipo de un media) */
  position: number; /* Indica la posición (orden) que ocupa un media en el location */
  clazz: MediaClazz; /* Indica qué tipo de foto es (tipo auxiliar de un media) */
  path: string; /* Ruta a la imagen: el tamaño se muestra como placeholder */
  isFallback: boolean; /* Indica si es un media que se ha obtenido a través del fallback, y no desde xmedia */
  sizes?: MediaSize[]; /* Listado de tamaños de un media: se tendrá que sustituir el placholder del path con uno de estos tamaños */
  /** xmedia set this media belongs to. Each set corresponds with a different Style */
  set?: number;
  contentType: MediaContentType; /* Indica el tipo de contenido del media (video, imagen) y su subtipo (extension) */
  metadata: MediaMetadata; /* Metadatos de un media, pe) datos útiles para debug */
  extraInfo?: MediaExtraInfo | null; /* Información extra para la contrucción de la imagen */
}

export interface MediaClazz {
  id: number; /* Id de un Clazz */
  type: MediaClazzType; /* Tipo de foto correspondiente a ese id */
}

export interface MediaSize {
  height: number; /* alto del media */
  width: number; /* ancho del media */
  code: string; /* id del tamaño */
}

export interface MediaContentType {
  type: MediaContentTypeType; /* indica si es una imagen o un video */
  subtype: string; /* Indica la extensión del media */
}

export interface MediaMetadata {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _debug: MediaMetadataDebug; /* Campo privado en el que se meterán datos de consulta para debug */
  colorName: string; /* Nombre del color */
}

export interface MediaMetadataDebug {
  productId: string; /* Id del producto */
}

export const MediaLocationTypeValues = ['category_page', 'product_page', 'checkout', 'colorcut',
  'related_product', 'bundle_component', 'search'] as const;
export type MediaLocation = typeof MediaLocationTypeValues[number];

export const MediaClazzTypeValues = ['main', 'secondary', 'colorcut', 'silhouette', 'alternative', 'double', 'alternativeDouble',
  'quadruple', 'video', 'videoDouble', 'unknown'] as const;
export type MediaClazzType = typeof MediaClazzTypeValues[number];

export const MediaContentTypeTypeValues = ['image', 'video', 'unknown'] as const;
export type MediaContentTypeType = typeof MediaContentTypeTypeValues[number];

/* Helpers models */

export interface MediaResolved {
  path: string;
  isFallback: boolean;
  clazz: MediaClazz;
  contentType: MediaContentType;
  location: MediaLocation;
  position: number;
  size?: MediaSize;
  metadata: MediaMetadata;
  extraInfo?: MediaResolvedExtraInfo | null;
}

export interface MediaItemsLocationPositionMap {
  [mediaItemId: string]: MediaLocationWithPosition[];
}

export interface MediaLocationWithPosition {
  location: MediaLocation;
  position: number;
}

export interface MediaExtraInfo {
  vimeo?: MediaVimeo[];
}

export interface MediaVimeo {
  id?: string;
  url?: string;
  size?: number;
}

export interface MediaResolvedExtraInfo {
  vimeo?: MediaResolvedVimeo[];
}

export interface MediaResolvedVimeo {
  id?: string;
  url?: string;
  size?: number;
}
